import { InjectionToken } from '@angular/core';

/**
 * Injection tokens for external API services used by section builders.
 * Using InjectionToken allows for better testing and optional dependencies.
 */

export const FIRMWARE_API_SERVICE = new InjectionToken('FirmwareApiService');
export const FIRMWARE_SERVICE = new InjectionToken('FirmwareService');
export const UPDATE_REGISTRY_API_SERVICE = new InjectionToken('UpdateRegistryApiService');
export const REPORTING_API_SERVICE = new InjectionToken('ReportingApiService');
export const TRANSACTIONS_API_SERVICE = new InjectionToken('TransactionsApiService');
